import { setConfig } from 'sensejs/core/config';

export interface ProjectConfig {
    BaseUrl: string;
    FullApiUrl: string;
    ImageUrl: string;
    Site: string;
    GoogleTagCode: string;
    Phone: number;
    Phonecost: number;
}

const config = require(`./private.${process.env.NODE_ENV}.json`) as ProjectConfig;
export const content = require(`./content/${config.Site}.json`) as any;

export const logo = require(`./assets/images/${config.Site}/logo.png`);
export const placeholder = require(`./assets/images/${config.Site}/placeholder.png`);
export const loader = require(`./assets/images/${config.Site}/loader.gif`);

if(window.loadTagManager){
    window.loadTagManager(window, document, 'script', 'dataLayer', config.GoogleTagCode);
}

export default config;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/config.ts